import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { CatalogProvider } from '@/hooks/CatalogContext';
import { AboutPage } from '@/pages/About';
import { CatalogPage } from '@/pages/Catalog';
import { ChangelogPage } from '@/pages/Changelog';
import { ComparePage } from '@/pages/Compare';
import { DrinkDetailPage } from '@/pages/DrinkDetail';
import { FeedbackPage } from '@/pages/Feedback';
import { GuideDetailPage } from '@/pages/GuideDetail';
import { GuidesPage } from '@/pages/Guides';
import { MethodologyPage } from '@/pages/Methodology';
import { NotFoundPage } from '@/pages/NotFound';
import { PrivacyPage } from '@/pages/Privacy';
import { TermsPage } from '@/pages/Terms';

export default function App() {
  return (
    <CatalogProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<CatalogPage />} />
          <Route path="beer" element={<CatalogPage category="beer" />} />
          <Route path="liquor" element={<CatalogPage category="liquor" />} />
          <Route path="wine" element={<CatalogPage category="wine" />} />
          <Route path="mixed-drinks" element={<CatalogPage category="mixed-drinks" />} />
          <Route path="seltzers" element={<CatalogPage category="seltzers" />} />
          <Route path="cider" element={<CatalogPage category="cider" />} />
          <Route path="drinks/:slug" element={<DrinkDetailPage />} />
          <Route path="compare" element={<ComparePage />} />
          <Route path="compare/:pair" element={<ComparePage />} />
          <Route path="guides" element={<GuidesPage />} />
          <Route path="guides/:slug" element={<GuideDetailPage />} />
          <Route path="methodology" element={<MethodologyPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="changelog" element={<ChangelogPage />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="home" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </CatalogProvider>
  );
}
